<template>
	<div>
		<Header :isExpanded="false" />

		<div class="bg-white mx-8 rounded p-6 prose prose-sm">
			<div class="text-left">
				<router-link to="/" style="text-decoration: none">
					&#8678; Back</router-link
				>
			</div>
			<p><strong>Terms &amp; Conditions</strong></p>
			<p>
				Oral B Electric Toothbrush Moneyback Promotion (“Oral B Moneyback
				Promotion”)
			</p>
			<p></p>
			<p>
				<em>Oral-B Moneyback Guarantee</em> is an ongoing promotion from 27th
				Nov ’20, only applicable on models of Oral-B Power Rechargeable
				Toothbrushes that are distributed in India.
			</p>
			<p>
				<strong>Models</strong>:- Oral-B Vitality 100 White Criss Cross -
				Electric Toothbrush, Oral-B Vitality 100 Blue Criss Cross - Electric
				Toothbrush, Oral-B Vitality 100 Black Criss Cross - Electric Toothbrush,
				Oral-B Pro 600 &amp; Oral-B Pro 2000 (otherwise known as Oral-B Pro 2
				2000 N). Oral-B Kids Rechargeable Toothbrush Star Wars &amp; Frozen
				characters.
			</p>
			<p>
				The scheme is valid for all residents of India who are above the age of
				18 Years.
			</p>
			<p>Claims must be made within <strong>30 days</strong> of purchase.</p>
			<p>
				Claims need to placed on the website
				<a href="https://pgtry.com/oralb-moneyback/"
					>https://pgtry.com/oralb-moneyback/</a
				>
			</p>
			<p>
				P&amp;G Consumer care team will get in touch within 48 hours of request
				on website, collection of product and refund processing will be done
				within 15 days subject to availability of user and other T&amp;Cs
			</p>
			<p>
				A maximum of 1 Claims may be made per Claimant. Use of multiple
				addresses/phone numbers to make multiple Claims will result in all
				Claims being rejected and where appropriate, may also entail appropriate
				action in law.
			</p>
			<p>
				Maximum entitlement of a claimant to Moneyback limited to MRP of
				product.
			</p>
			<p>
				The Oral B Moneyback Promotion is valid only on purchases made on
				Amazon, Flipkart, FirstCry, Nykaa, BigBasket and PGShop.
			</p>
			<p>
				All refunds under this Moneyback Promotion will be made via Cheque,
				Amazon eVouchers or PgShop voucher depending on the option opted by the
				consumer
			</p>
			<p>
				Employees of GIL and or any third parties engaged by it in connection
				with this Promotion, and immediate family members of such persons are
				ineligible to apply.
			</p>
			<p>
				GIL reserves the right to reject any and all Claims that are contrary to
				these Terms and Conditions. All disputes shall be subject to the
				exclusive jurisdiction of the Courts in Mumbai.
			</p>
		</div>
		<Footer />
	</div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
export default {
	name: 'Home',
	components: {
		Header,
		Footer,
	},
}
</script>
